import { Question } from '../types';

export const declensionQuestions: Question[] = [
  {
    id: 'decl1',
    text: 'According to Al-Ajrumiyyah, what are the three cases in Arabic grammar?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'رفع (raf\')', isCorrect: true },
      { id: 'b', text: 'نصب (nasb)', isCorrect: true },
      { id: 'c', text: 'خفض (khafd)', isCorrect: true },
      { id: 'd', text: 'جزم (jazm)', isCorrect: false },
      { id: 'e', text: 'بناء (bina\')', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah mentions that there are three cases in Arabic grammar: رفع (raf\'), نصب (nasb), and خفض (khafd). جزم (jazm) applies only to verbs, not to nouns.',
    ajrumiyyahReference: 'Chapter on I\'rab (باب الإعراب)',
    topic: 'declension'
  },
  {
    id: 'decl2',
    text: 'According to Al-Ajrumiyyah, what are the signs of raf\' (nominative case)?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'الضمة (damma)', isCorrect: true },
      { id: 'b', text: 'الواو (waw)', isCorrect: true },
      { id: 'c', text: 'الألف (alif)', isCorrect: true },
      { id: 'd', text: 'ثبوت النون (retention of nun)', isCorrect: true },
      { id: 'e', text: 'الفتحة (fatha)', isCorrect: false },
      { id: 'f', text: 'الكسرة (kasra)', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah mentions that the signs of raf\' (nominative case) are: الضمة, الواو, الألف, and ثبوت النون.',
    ajrumiyyahReference: 'Chapter on Signs of I\'rab (باب علامات الإعراب)',
    topic: 'declension'
  },
  {
    id: 'decl3',
    text: 'According to Al-Ajrumiyyah, what are the signs of nasb (accusative case)?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'الفتحة (fatha)', isCorrect: true },
      { id: 'b', text: 'الألف (alif)', isCorrect: false },
      { id: 'c', text: 'الكسرة (kasra)', isCorrect: true },
      { id: 'd', text: 'الياء (ya\')', isCorrect: true },
      { id: 'e', text: 'حذف النون (omission of nun)', isCorrect: true }
    ],
    explanation: 'Al-Ajrumiyyah mentions that the signs of nasb (accusative case) are: الفتحة, الكسرة, الياء, and حذف النون.',
    ajrumiyyahReference: 'Chapter on Signs of I\'rab (باب علامات الإعراب)',
    topic: 'declension'
  },
  {
    id: 'decl4',
    text: 'According to Al-Ajrumiyyah, what are the signs of khafd (genitive case)?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'الكسرة (kasra)', isCorrect: true },
      { id: 'b', text: 'الياء (ya\')', isCorrect: true },
      { id: 'c', text: 'الفتحة (fatha)', isCorrect: true },
      { id: 'd', text: 'الضمة (damma)', isCorrect: false },
      { id: 'e', text: 'الواو (waw)', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah mentions that the signs of khafd (genitive case) are: الكسرة, الياء, and الفتحة.',
    ajrumiyyahReference: 'Chapter on Signs of I\'rab (باب علامات الإعراب)',
    topic: 'declension'
  },
  {
    id: 'decl5',
    text: 'According to Al-Ajrumiyyah, what are the signs of jazm (jussive case)?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'السكون (sukun)', isCorrect: true },
      { id: 'b', text: 'الحذف (omission)', isCorrect: true },
      { id: 'c', text: 'الفتحة (fatha)', isCorrect: false },
      { id: 'd', text: 'الكسرة (kasra)', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah mentions that the signs of jazm (jussive case) are: السكون and الحذف.',
    ajrumiyyahReference: 'Chapter on Signs of I\'rab (باب علامات الإعراب)',
    topic: 'declension'
  },
  {
    id: 'decl6',
    text: 'According to Al-Ajrumiyyah, which of these is marfu\' (nominative)?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'الفاعل (the subject)', isCorrect: true },
      { id: 'b', text: 'المبتدأ (the subject of a nominal sentence)', isCorrect: true },
      { id: 'c', text: 'الخبر (the predicate)', isCorrect: true },
      { id: 'd', text: 'المفعول به (the direct object)', isCorrect: false },
      { id: 'e', text: 'اسم إن (the noun of inna)', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah mentions that the الفاعل, المبتدأ, and الخبر are marfu\' (nominative).',
    ajrumiyyahReference: 'Chapter on مرفوعات الأسماء (The Nominative Nouns)',
    topic: 'declension'
  },
  {
    id: 'decl7',
    text: 'According to Al-Ajrumiyyah, which of these is mansub (accusative)?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'المفعول به (the direct object)', isCorrect: true },
      { id: 'b', text: 'اسم إن (the noun of inna)', isCorrect: true },
      { id: 'c', text: 'خبر كان (the predicate of kana)', isCorrect: true },
      { id: 'd', text: 'الحال (the circumstantial accusative)', isCorrect: true },
      { id: 'e', text: 'المبتدأ (the subject of a nominal sentence)', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah mentions that the المفعول به, اسم إن, خبر كان, and الحال are mansub (accusative).',
    ajrumiyyahReference: 'Chapter on منصوبات الأسماء (The Accusative Nouns)',
    topic: 'declension'
  },
  {
    id: 'decl8',
    text: 'According to Al-Ajrumiyyah, which of these is makhfud (genitive)?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'المضاف إليه (the possessor in a genitive construction)', isCorrect: true },
      { id: 'b', text: 'الاسم المجرور (the noun preceded by a preposition)', isCorrect: true },
      { id: 'c', text: 'المفعول به (the direct object)', isCorrect: false },
      { id: 'd', text: 'الفاعل (the subject)', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah mentions that the المضاف إليه and الاسم المجرور are makhfud (genitive).',
    ajrumiyyahReference: 'Chapter on مخفوضات الأسماء (The Genitive Nouns)',
    topic: 'declension'
  },
  {
    id: 'decl9',
    text: 'According to Al-Ajrumiyyah, which of these is majzum (jussive)?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'الفعل المضارع بعد لم (the present tense verb after lam)', isCorrect: true },
      { id: 'b', text: 'جواب الشرط (the answer to a condition)', isCorrect: true },
      { id: 'c', text: 'الفعل الماضي (the past tense verb)', isCorrect: false },
      { id: 'd', text: 'الاسم (the noun)', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah mentions that the الفعل المضارع بعد لم and جواب الشرط are majzum (jussive).',
    ajrumiyyahReference: 'Chapter on مجزومات الأفعال (The Jussive Verbs)',
    topic: 'declension'
  },
  {
    id: 'decl10',
    text: 'In the sentence جاءَ زيدٌ (Zayd came), identify the grammatical case of زيدٌ according to Al-Ajrumiyyah:',
    type: 'single',
    options: [
      { id: 'a', text: 'مرفوع (nominative)', isCorrect: true },
      { id: 'b', text: 'منصوب (accusative)', isCorrect: false },
      { id: 'c', text: 'مجرور (genitive)', isCorrect: false },
      { id: 'd', text: 'مجزوم (jussive)', isCorrect: false }
    ],
    explanation: 'In the sentence جاءَ زيدٌ, زيدٌ is the فاعل (subject) of the verb جاءَ, and according to Al-Ajrumiyyah, the فاعل is always مرفوع (nominative).',
    ajrumiyyahReference: 'Chapter on مرفوعات الأسماء (The Nominative Nouns) - الفاعل',
    topic: 'declension'
  },
  {
    id: 'decl11',
    text: 'In the sentence رأيتُ زيداً (I saw Zayd), identify the grammatical case of زيداً according to Al-Ajrumiyyah:',
    type: 'single',
    options: [
      { id: 'a', text: 'مرفوع (nominative)', isCorrect: false },
      { id: 'b', text: 'منصوب (accusative)', isCorrect: true },
      { id: 'c', text: 'مجرور (genitive)', isCorrect: false },
      { id: 'd', text: 'مجزوم (jussive)', isCorrect: false }
    ],
    explanation: 'In the sentence رأيتُ زيداً, زيداً is the مفعول به (direct object) of the verb رأيتُ, and according to Al-Ajrumiyyah, the مفعول به is always منصوب (accusative).',
    ajrumiyyahReference: 'Chapter on منصوبات الأسماء (The Accusative Nouns) - المفعول به',
    topic: 'declension'
  },
  {
    id: 'decl12',
    text: 'In the sentence مررتُ بزيدٍ (I passed by Zayd), identify the grammatical case of زيدٍ according to Al-Ajrumiyyah:',
    type: 'single',
    options: [
      { id: 'a', text: 'مرفوع (nominative)', isCorrect: false },
      { id: 'b', text: 'منصوب (accusative)', isCorrect: false },
      { id: 'c', text: 'مجرور (genitive)', isCorrect: true },
      { id: 'd', text: 'مجزوم (jussive)', isCorrect: false }
    ],
    explanation: 'In the sentence مررتُ بزيدٍ, زيدٍ is the اسم مجرور (noun preceded by a preposition) by the preposition ب, and according to Al-Ajrumiyyah, the اسم مجرور is always مجرور (genitive).',
    ajrumiyyahReference: 'Chapter on مخفوضات الأسماء (The Genitive Nouns) - الاسم المجرور',
    topic: 'declension'
  },
  {
    id: 'decl13',
    text: 'In the sentence لم يذهبْ زيدٌ (Zayd did not go), identify the grammatical case of يذهبْ according to Al-Ajrumiyyah:',
    type: 'single',
    options: [
      { id: 'a', text: 'مرفوع (nominative)', isCorrect: false },
      { id: 'b', text: 'منصوب (accusative)', isCorrect: false },
      { id: 'c', text: 'مجرور (genitive)', isCorrect: false },
      { id: 'd', text: 'مجزوم (jussive)', isCorrect: true }
    ],
    explanation: 'In the sentence لم يذهبْ زيدٌ, يذهبْ is a فعل مضارع (present tense verb) preceded by لم, and according to Al-Ajrumiyyah, the فعل مضارع after لم is always مجزوم (jussive).',
    ajrumiyyahReference: 'Chapter on مجزومات الأفعال (The Jussive Verbs)',
    topic: 'declension'
  },
  {
    id: 'decl14',
    text: 'In the sentence إن زيداً قائمٌ (Indeed, Zayd is standing), identify the grammatical case of زيداً according to Al-Ajrumiyyah:',
    type: 'single',
    options: [
      { id: 'a', text: 'مرفوع (nominative)', isCorrect: false },
      { id: 'b', text: 'منصوب (accusative)', isCorrect: true },
      { id: 'c', text: 'مجرور (genitive)', isCorrect: false },
      { id: 'd', text: 'مجزوم (jussive)', isCorrect: false }
    ],
    explanation: 'In the sentence إن زيداً قائمٌ, زيداً is the اسم إن (noun of inna), and according to Al-Ajrumiyyah, the اسم إن is always منصوب (accusative).',
    ajrumiyyahReference: 'Chapter on النواسخ (The Cancelers) - إن وأخواتها',
    topic: 'declension'
  },
  {
    id: 'decl15',
    text: 'In the sentence كان زيدٌ قائماً (Zayd was standing), identify the grammatical case of قائماً according to Al-Ajrumiyyah:',
    type: 'single',
    options: [
      { id: 'a', text: 'مرفوع (nominative)', isCorrect: false },
      { id: 'b', text: 'منصوب (accusative)', isCorrect: true },
      { id: 'c', text: 'مجرور (genitive)', isCorrect: false },
      { id: 'd', text: 'مجزوم (jussive)', isCorrect: false }
    ],
    explanation: 'In the sentence كان زيدٌ قائماً, قائماً is the خبر كان (predicate of kana), and according to Al-Ajrumiyyah, the خبر كان is always منصوب (accusative).',
    ajrumiyyahReference: 'Chapter on النواسخ (The Cancelers) - كان وأخواتها',
    topic: 'declension'
  },
  {
    id: 'decl16',
    text: 'According to Al-Ajrumiyyah, which of the following takes the sign of raf\' as waw (الواو)?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'جمع المذكر السالم (sound masculine plural)', isCorrect: true },
      { id: 'b', text: 'الأسماء الخمسة (the five nouns)', isCorrect: true },
      { id: 'c', text: 'المثنى (dual)', isCorrect: false },
      { id: 'd', text: 'جمع المؤنث السالم (sound feminine plural)', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah mentions that the sign of raf\' is waw (الواو) in جمع المذكر السالم (sound masculine plural) and الأسماء الخمسة (the five nouns).',
    ajrumiyyahReference: 'Chapter on Signs of I\'rab (باب علامات الإعراب)',
    topic: 'declension'
  },
  {
    id: 'decl17',
    text: 'According to Al-Ajrumiyyah, the five nouns (الأسماء الخمسة) are:',
    type: 'multiple',
    options: [
      { id: 'a', text: 'أب (father)', isCorrect: true },
      { id: 'b', text: 'أخ (brother)', isCorrect: true },
      { id: 'c', text: 'حم (father-in-law)', isCorrect: true },
      { id: 'd', text: 'فو (mouth)', isCorrect: true },
      { id: 'e', text: 'ذو (possessor)', isCorrect: true },
      { id: 'f', text: 'يد (hand)', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah lists the five nouns as: أب (father), أخ (brother), حم (father-in-law), فو (mouth), and ذو (possessor).',
    ajrumiyyahReference: 'Chapter on الإعراب (I\'rab) - الأسماء الخمسة',
    topic: 'declension'
  },
  {
    id: 'decl18',
    text: 'According to Al-Ajrumiyyah, what are the conditions for the five nouns (الأسماء الخمسة) to be inflected with letters?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'To be singular (مفردة)', isCorrect: true },
      { id: 'b', text: 'To be possessed (مضافة)', isCorrect: true },
      { id: 'c', text: 'Not to be possessed to a yaa of the speaker (غير مضافة إلى ياء المتكلم)', isCorrect: true },
      { id: 'd', text: 'To be in the dual form (مثنى)', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah states that for the five nouns to be inflected with letters, they must be singular, possessed, and not possessed to a yaa of the speaker.',
    ajrumiyyahReference: 'Chapter on الإعراب (I\'rab) - الأسماء الخمسة',
    topic: 'declension'
  },
  {
    id: 'decl19',
    text: 'In Al-Ajrumiyyah, what is the grammatical term for words that do not change their endings?',
    type: 'single',
    options: [
      { id: 'a', text: 'معرب (declinable)', isCorrect: false },
      { id: 'b', text: 'مبني (indeclinable)', isCorrect: true },
      { id: 'c', text: 'منصوب (accusative)', isCorrect: false },
      { id: 'd', text: 'مجزوم (jussive)', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah uses the term مبني (indeclinable) for words that do not change their endings regardless of their grammatical position.',
    ajrumiyyahReference: 'Chapter on المبني والمعرب (Indeclinable and Declinable)',
    topic: 'declension'
  },
  {
    id: 'decl20',
    text: 'According to Al-Ajrumiyyah, which of these are indeclinable (مبني)?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'الضمائر (pronouns)', isCorrect: true },
      { id: 'b', text: 'أسماء الإشارة (demonstrative pronouns)', isCorrect: true },
      { id: 'c', text: 'الأسماء الموصولة (relative pronouns)', isCorrect: true },
      { id: 'd', text: 'أسماء الاستفهام (interrogative pronouns)', isCorrect: true },
      { id: 'e', text: 'المثنى (dual nouns)', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah lists pronouns, demonstrative pronouns, relative pronouns, and interrogative pronouns among the indeclinable nouns.',
    ajrumiyyahReference: 'Chapter on المبني والمعرب (Indeclinable and Declinable)',
    topic: 'declension'
  },
  {
    id: 'decl21',
    text: 'According to Al-Ajrumiyyah, what states can indeclinable words (المبنيات) be in?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'مبني على الفتح (fixed on fatha)', isCorrect: true },
      { id: 'b', text: 'مبني على الضم (fixed on damma)', isCorrect: true },
      { id: 'c', text: 'مبني على الكسر (fixed on kasra)', isCorrect: true },
      { id: 'd', text: 'مبني على السكون (fixed on sukun)', isCorrect: true },
      { id: 'e', text: 'مبني على الواو (fixed on waw)', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah states that indeclinable words can be fixed on fatha, damma, kasra, or sukun.',
    ajrumiyyahReference: 'Chapter on المبني والمعرب (Indeclinable and Declinable)',
    topic: 'declension'
  },
  {
    id: 'decl22',
    text: 'In Al-Ajrumiyyah, what is the grammatical case of the verb in the following sentence: "يَذْهَبُ زَيْدٌ إِلَى المَدْرَسَةِ"?',
    type: 'single',
    options: [
      { id: 'a', text: 'مرفوع (nominative)', isCorrect: true },
      { id: 'b', text: 'منصوب (accusative)', isCorrect: false },
      { id: 'c', text: 'مجرور (genitive)', isCorrect: false },
      { id: 'd', text: 'مجزوم (jussive)', isCorrect: false }
    ],
    explanation: 'According to Al-Ajrumiyyah, the present tense verb (الفعل المضارع) is in the nominative case (مرفوع) when it is not preceded by a particle that puts it in the accusative or jussive case.',
    ajrumiyyahReference: 'Chapter on إعراب الفعل (Declension of Verbs)',
    topic: 'declension'
  },
  {
    id: 'decl23',
    text: 'According to Al-Ajrumiyyah, what are the particles that put the present tense verb in the accusative case (نواصب الفعل المضارع)?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'أَنْ (an)', isCorrect: true },
      { id: 'b', text: 'لَنْ (lan)', isCorrect: true },
      { id: 'c', text: 'كَيْ (kay)', isCorrect: true },
      { id: 'd', text: 'إِذَنْ (idhan)', isCorrect: true },
      { id: 'e', text: 'لَمْ (lam)', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah lists four particles that put the present tense verb in the accusative case: أَنْ, لَنْ, كَيْ, and إِذَنْ.',
    ajrumiyyahReference: 'Chapter on نواصب الفعل المضارع (Accusative Particles of the Present Tense Verb)',
    topic: 'declension'
  },
  {
    id: 'decl24',
    text: 'According to Al-Ajrumiyyah, what are the particles that put the present tense verb in the jussive case (جوازم الفعل المضارع)?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'لَمْ (lam)', isCorrect: true },
      { id: 'b', text: 'لَمَّا (lamma)', isCorrect: true },
      { id: 'c', text: 'لام الأمر (lam of command)', isCorrect: true },
      { id: 'd', text: 'لا الناهية (prohibitive la)', isCorrect: true },
      { id: 'e', text: 'لَنْ (lan)', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah mentions these particles among those that put the present tense verb in the jussive case: لَمْ, لَمَّا, لام الأمر, and لا الناهية.',
    ajrumiyyahReference: 'Chapter on جوازم الفعل المضارع (Jussive Particles of the Present Tense Verb)',
    topic: 'declension'
  },
  {
    id: 'decl25',
    text: 'In the sentence "لَنْ يَذْهَبَ زَيْدٌ" from Al-Ajrumiyyah, what is the grammatical case of the verb "يَذْهَبَ"?',
    type: 'single',
    options: [
      { id: 'a', text: 'مرفوع (nominative)', isCorrect: false },
      { id: 'b', text: 'منصوب (accusative)', isCorrect: true },
      { id: 'c', text: 'مجرور (genitive)', isCorrect: false },
      { id: 'd', text: 'مجزوم (jussive)', isCorrect: false }
    ],
    explanation: 'According to Al-Ajrumiyyah, when a present tense verb is preceded by لَنْ (lan), it is put in the accusative case (منصوب).',
    ajrumiyyahReference: 'Chapter on نواصب الفعل المضارع (Accusative Particles of the Present Tense Verb)',
    topic: 'declension'
  },
  {
    id: 'decl26',
    text: 'According to Al-Ajrumiyyah, what is the sign of nasb (accusative) in the dual and sound masculine plural forms of the present tense verb?',
    type: 'single',
    options: [
      { id: 'a', text: 'الفتحة (fatha)', isCorrect: false },
      { id: 'b', text: 'الكسرة (kasra)', isCorrect: false },
      { id: 'c', text: 'حذف النون (omission of nun)', isCorrect: true },
      { id: 'd', text: 'حذف حرف العلة (omission of the weak letter)', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah states that the sign of nasb in the dual and sound masculine plural forms of the present tense verb is the omission of nun (حذف النون).',
    ajrumiyyahReference: 'Chapter on Signs of I\'rab (باب علامات الإعراب)',
    topic: 'declension'
  },
  {
    id: 'decl27',
    text: 'In Al-Ajrumiyyah, what is the sign of jazm (jussive) in a sound present tense verb?',
    type: 'single',
    options: [
      { id: 'a', text: 'الفتحة (fatha)', isCorrect: false },
      { id: 'b', text: 'الكسرة (kasra)', isCorrect: false },
      { id: 'c', text: 'السكون (sukun)', isCorrect: true },
      { id: 'd', text: 'حذف النون (omission of nun)', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah mentions that the sign of jazm in a sound present tense verb is sukun (السكون).',
    ajrumiyyahReference: 'Chapter on Signs of I\'rab (باب علامات الإعراب)',
    topic: 'declension'
  },
  {
    id: 'decl28',
    text: 'According to Al-Ajrumiyyah, what is the sign of jazm in a present tense verb ending with a weak letter (الفعل المضارع المعتل الآخر)?',
    type: 'single',
    options: [
      { id: 'a', text: 'السكون (sukun)', isCorrect: false },
      { id: 'b', text: 'حذف حرف العلة (omission of the weak letter)', isCorrect: true },
      { id: 'c', text: 'الفتحة (fatha)', isCorrect: false },
      { id: 'd', text: 'الكسرة (kasra)', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah states that the sign of jazm in a present tense verb ending with a weak letter is the omission of that weak letter (حذف حرف العلة).',
    ajrumiyyahReference: 'Chapter on Signs of I\'rab (باب علامات الإعراب)',
    topic: 'declension'
  },
  {
    id: 'decl29',
    text: 'In Al-Ajrumiyyah, which of the following is considered a verbal noun (مصدر)?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'ضَرْب (striking)', isCorrect: true },
      { id: 'b', text: 'إِكْرَام (honoring)', isCorrect: true },
      { id: 'c', text: 'ضَارِب (striker)', isCorrect: false },
      { id: 'd', text: 'مَضْرُوب (struck)', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah identifies verbal nouns (مصدر) as nouns that indicate the action without any tense, like ضَرْب (striking) and إِكْرَام (honoring).',
    ajrumiyyahReference: 'Chapter on المصادر (Verbal Nouns)',
    topic: 'declension'
  },
  {
    id: 'decl30',
    text: 'According to Al-Ajrumiyyah, which case is used for the excepted noun (المستثنى) after إلا when the sentence is affirmative and complete?',
    type: 'single',
    options: [
      { id: 'a', text: 'الرفع (nominative)', isCorrect: false },
      { id: 'b', text: 'النصب (accusative)', isCorrect: true },
      { id: 'c', text: 'الجر (genitive)', isCorrect: false },
      { id: 'd', text: 'الجزم (jussive)', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah states that the excepted noun after إلا is in the accusative case when the sentence is affirmative and complete.',
    ajrumiyyahReference: 'باب الاستثناء (Chapter on Exceptions)',
    topic: 'declension',
    tags: ['exception']
  }
];
